import { Component, forwardRef, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownComponent),
      multi: true
    }
  ]
})
export class DropdownComponent implements OnInit, ControlValueAccessor {
  @Input() id: string;
  @Input() label: string;
  @Input() options$ = new BehaviorSubject([{ label: 'text', value: null }]);

  @Input() set options(item) {

    if (this.isArray(item)) {
      this.options$.next(item);
    } else {
      const obs = item as Observable<any>;
      if (!obs) {
        return
      }
      obs.pipe(untilDestroyed(this)).subscribe(opts => this.options$.next(opts));
    }
  }

  @Input() valuePrimitive = true;
  public _value: string;
  @Input() disabled: boolean;
  @Output() onValueChanged = new EventEmitter<string>();
  
  constructor() {
  }

  onChanged: any = (value) => {
    if (this.onValueChanged)
      this.onValueChanged.emit(value);
  };

  onTouched: any = () => {
  };

  ngOnInit() {
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  writeValue(obj: any): void {
    this._value = obj;
  }

  change(option: any) {

    // const value = this.valuePrimitive ? option.value : option;
    // this._value = value;
    this.onChanged(this._value);
  }

  isArray(data) {
    return Array.isArray(data);
  }
}
